import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslate } from 'src/locales';

interface ByzMuiAdButtonDogrulaProps {
  patientName?: string;
}

const ByzMuiAdButtonDogrula: React.FC<ByzMuiAdButtonDogrulaProps> = ({ patientName }) => {
  const { t } = useTranslate();
  
  return (
    <Box
      sx={{
        position: 'relative',
        borderRadius: '20px',
        backgroundColor: 'rgba(3, 202, 26, 0.2)',
        border: '1px solid #03ca1a',
        boxSizing: 'border-box',
        width: '100%',
        overflow: 'hidden',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 10px',
        textAlign: 'left',
        fontSize: '13px',
        color: '#03ca1a',
        fontFamily: 'Poppins',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
        }}
      >
        <Typography
          sx={{
            position: 'relative',
            lineHeight: '22px',
            textTransform: 'capitalize',
            fontSize: '13px',
            color: '#03ca1a',
            fontFamily: 'Poppins',
          }}
        >
          {patientName 
            ? `${patientName} ${t('nurse.order-medicine.buttons.identity-verified')}` 
            : t('nurse.order-medicine.buttons.identity-verified-default')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ByzMuiAdButtonDogrula;

